import { base64ToArrayBuffer } from './base64-arraybuffer.function';
import { saveAs } from 'file-saver';

export const exportFile = (base64String: string, fileType: string, fileName: string, fileExt: String): void => {
  var byteArray = base64ToArrayBuffer(base64String)
  let blob: any = new Blob([byteArray], { type: fileType });
  saveAs(blob, `${fileName}.${fileExt}`, true);
}
